module.exports = __webpack_public_path__ + "static/media/likeRed.5e221457.svg";